import { Outlet, useLocation } from 'react-router-dom';
import { Logo } from '../../components/brand/Logo';

/** Unauthenticated shell for login / invitation / recovery (Frontend §Routing).
 * The register and login pages get a wider frame for their split layout; every
 * other auth page stays a narrow, centered card. */
export function AuthLayout() {
  const { pathname } = useLocation();
  const wide = pathname.startsWith('/register') || pathname.startsWith('/login');
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center px-6 py-16">
      {/* Ambient green glow — the eye watching from the dark. */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10"
        style={{
          background: 'radial-gradient(55% 45% at 50% 0%, var(--iris-dim), transparent 70%)',
        }}
      />
      <div className={wide ? 'w-full max-w-4xl' : 'w-full max-w-sm'}>
        <div className="mb-8 flex justify-center">
          <Logo size={30} />
        </div>
        <Outlet />
      </div>
    </div>
  );
}
